/* oxlint-disable eslint/no-restricted-imports */
import { useContext } from 'react';
import {
  ReactReduxContext,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
  useStore as useReduxStore,
} from 'react-redux';

import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AppDispatch, AppStore, ExtraArguments, RootState } from './store';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  extra: ExtraArguments;
}>();

export const useStore = useReduxStore.withTypes<AppStore>();
export const useDispatch = useReduxDispatch.withTypes<AppDispatch>();
export const useSelector = useReduxSelector.withTypes<RootState>();

/**
 * El estado de Redux si hay `Provider`, sin suscribirse a cambios (se lee al
 * pintar). Para piezas que también se prueban sueltas, sin store: ahí da null.
 */
export function useEstadoSiHay(): RootState | null {
  const contexto = useContext(ReactReduxContext);
  return (contexto?.store.getState() as RootState | undefined) ?? null;
}
